import React, { useState, useEffect } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddLibraryForm from "./library-forms/add-library-form";
import { getLibraryList } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";
const LibraryTable = () => {
  const { toggleHostelMenu } = useGlobalState();

  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryList}
      tab1={"Library"}
      tab2={"Library"}
      AddForm={AddLibraryForm}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default LibraryTable;
